var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 313,
    viewBox: "0 0 480 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.857 257.739L415.127 311.879C420.23 313.079 425.341 309.915 426.54 304.812L432.691 278.65C433.891 273.547 430.727 268.436 425.623 267.236L180.825 209.68L81.148 251.627C76.316 253.66 74.047 259.226 76.0806 264.059L86.5041 288.829C88.5385 293.662 94.1044 295.931 98.9365 293.897L184.857 257.739Z",
    fill: "url(#paint0_linear_202_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.764 148.579L439.009 210.23C444.105 211.465 449.237 208.336 450.472 203.241L456.805 177.123C458.041 172.028 454.912 166.896 449.817 165.66L180.919 100.457L41.8644 158.813C37.0299 160.842 34.7554 166.406 36.7843 171.24L47.1838 196.021C49.2126 200.855 54.7765 203.13 59.611 201.101L184.764 148.579Z",
    fill: "url(#paint1_linear_202_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.774 48.1222L461.946 115.237C467.042 116.471 472.173 113.34 473.407 108.245L479.731 82.1251C480.965 77.0291 477.834 71.898 472.738 70.6639L180.909 0L5.81728 73.5935C0.983894 75.625 -1.28746 81.19 0.744095 86.023L11.1572 110.798C13.1888 115.631 18.7539 117.903 23.5873 115.872L184.774 48.1222Z",
    fill: "url(#paint2_linear_202_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_3",
    x1: 26.1072,
    y1: 230.876,
    x2: 289.07,
    y2: 372.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062134",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_202_3",
    x1: 41.7711,
    y1: 119.805,
    x2: 248.724,
    y2: 287.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062134",
    stopOpacity: 0.47
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_202_3",
    x1: -1.42321,
    y1: 21.5506,
    x2: 242.078,
    y2: 181.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062134",
    stopOpacity: 0.47
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo_mobile.ad5add0a8354fb2fc171f43e2374bf16.svg";
export { ForwardRef as ReactComponent };